import { CSSTransition, TransitionGroup } from 'react-transition-group'
import * as firebase from 'firebase'
import * as React from 'react'
import { Route, Switch, withRouter, RouteComponentProps } from 'react-router-dom'

import Beat from './Beat'
import Constellation from './Constellation'
import Draw from './Draw'
import Earth from './Sphere/Earth'
import Flock from './Flock'
import Flocking from './Flocking'
import Gravity from './Gravity'
import Grid from './Grid'
import KeyCapturer from './KeyCapturer'
import Lines from './Lines'
import Meander from './Meander'
import Storage from './Storage'
import * as Styles from './Type.styles'
import Sun from './Sphere/Sun'

const ROTATE_SKETCHES = ['flock', 'earth', 'draw', 'lines', 'meander', 'beat']

interface Props extends RouteComponentProps<any> {
  rotate: boolean
  userID?: string
}

interface State {
  currentKeys: string[]
}

class Type extends React.Component<Props, State> {
  private storage: Storage

  constructor(props: Props) {
    super(props)

    this.state = { currentKeys: [] }
    this.handleOnKeyDown = this.handleOnKeyDown.bind(this)
    this.handleOnKeyUp = this.handleOnKeyUp.bind(this)
    this.redirectToRandomSketch = this.redirectToRandomSketch.bind(this)
    this.storage = new Storage()
  }

  componentDidMount() {
    if (this.props.rotate) {
      if (ROTATE_SKETCHES.indexOf(this.props.location.pathname.replace(/^\/(norotate\/)?/, '')) === -1) {
        this.redirectToRandomSketch()
      }
      window.setInterval(this.redirectToRandomSketch, 15000)
    }
  }

  render() {
    let { path } = this.props.match

    if (path === '/') {
      path = ''
    }

    return (
      <Styles.Root>
        <KeyCapturer
          onKeyDown={this.handleOnKeyDown}
          onKeyUp={this.handleOnKeyUp}
        />

        <Route
          render={({ location }) => (
            <TransitionGroup enter={false}>
              <CSSTransition key={location.key} classNames="Type__fade" timeout={Styles.TRANSITION_DURATION}>
                <Switch location={location}>
                  <Route
                    path={`${path}/gravity`}
                    exact={true}
                    component={Gravity}
                  />

                  <Route
                    path={`${path}/constellation`}
                    exact={true}
                    component={Constellation}
                  />

                  <Route
                    path={`${path}/flock`}
                    exact={true}
                    component={Flock}
                  />

                  <Route
                    path={`${path}/flocking`}
                    exact={true}
                    component={Flocking}
                  />

                  <Route
                    path={`${path}/earth`}
                    exact={true}
                    component={Earth}
                  />

                  <Route
                    path={`${path}/sun`}
                    exact={true}
                    component={Sun}
                  />

                  <Route
                    path={`${path}/draw`}
                    exact={true}
                    component={Draw}
                  />

                  <Route
                    path={`${path}/lines`}
                    exact={true}
                    component={Lines}
                  />

                  <Route
                    path={`${path}/meander`}
                    exact={true}
                    component={Meander}
                  />

                  <Route
                    path={`${path}/beat`}
                    exact={true}
                    component={Beat}
                  />

                  <Route
                    path={`${path}/grid`}
                    exact={true}
                    component={Grid}
                  />
                </Switch>
              </CSSTransition>
            </TransitionGroup>
          )}
        />
      </Styles.Root>
    )
  }

  private handleOnKeyDown(key: string): void {
    if (this.state.currentKeys.indexOf(key) === -1) {
      this.setState({ currentKeys: [...this.state.currentKeys, key] })

      if (this.props.userID) {
        this.storage.handleAction({
          action: 'start',
          key,
          date: firebase.firestore.FieldValue.serverTimestamp(),
          userID: this.props.userID,
        })
      }
    }
  }

  private handleOnKeyUp(key: string): void {
    if (this.state.currentKeys.indexOf(key) !== -1) {
      this.setState({ currentKeys: this.state.currentKeys.filter(keyToRemove => key !== keyToRemove) })

      if (this.props.userID) {
        this.storage.handleAction({
          action: 'end',
          key,
          date: firebase.firestore.FieldValue.serverTimestamp(),
          userID: this.props.userID,
        })
      }
    }
  }

  private redirectToRandomSketch() {
    let newPath = '/' + ROTATE_SKETCHES[Math.floor(ROTATE_SKETCHES.length * Math.random())]

    // Ensure that it actually changed
    while (newPath === this.props.location.pathname) {
      newPath = '/' + ROTATE_SKETCHES[Math.floor(ROTATE_SKETCHES.length * Math.random())]
    }

    window.location.href = newPath
  }
}

export default withRouter(Type)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Type.tsx